import { memo, useCallback, useMemo, useState } from "react";
import { useDrag } from "react-dnd";
import { Typography, makeStyles } from "@material-ui/core";

import ShortTextIcon from "@mui/icons-material/ShortText";
import SubjectIcon from "@mui/icons-material/Subject";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import TocIcon from "@mui/icons-material/Toc";
import dropdownImg from "../../assets/icons/dropdown.png";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const style = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "start",
};
const useStyles = makeStyles(theme => ({
  iconStyle: {
    marginRight: 10,
    color: "#fff",
    backgroundColor: "#0057B2",
    borderRadius: 4,
  },
}));
export const ComponentDragBox = memo(function ComponentDragBox({
  component,
  text,
  icon,
  children,
}) {
  const classes = useStyles();
  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: component,
      collect: monitor => ({
        isDragging: monitor.isDragging(),
      }),
    }),
    [component, text]
  );

  const containerStyle = useMemo(
    () => ({
      ...style,
      opacity: isDragging ? 0.4 : 1,
      cursor: isDragging ? "grabbing" : "grab",
    }),
    [isDragging]
  );
  return (
    <div ref={drag} style={containerStyle} role="ComponentDragBox">
      {icon === "ShortTextIcon" && <ShortTextIcon className={classes.iconStyle} />}
      {icon === "SubjectIcon" && <SubjectIcon className={classes.iconStyle} />}
      {icon === "RadioButtonCheckedIcon" && (
        <RadioButtonCheckedIcon className={classes.iconStyle} />
      )}
      {icon === "TocIcon" && <TocIcon className={classes.iconStyle} />}
      {icon === "DropDownIcon" && (
        <img
          style={{
            marginRight: 10,
            borderRadius: 4,
            height: 24,
          }}
          src={dropdownImg}
        />
      )}
      {icon === "CheckBoxIcon" && <CheckBoxIcon className={classes.iconStyle} />}
      <Typography variant="h3" style={{ paddingTop: 3 }}>
        {text}
      </Typography>
    </div>
  );
});
